var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportTableNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 1.2H2C1.55817 1.2 1.2 1.55817 1.2 2V5.8H23.8V2C23.8 1.55817 23.4418 1.2 23 1.2ZM2 0C0.895431 0 0 0.89543 0 2V7H25V2C25 0.895431 24.1046 0 23 0H2Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 15.2H1V14H17V15.2Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 7.2H23.8V10H25V6H0V21C0 22.1046 0.89543 23 2 23H23C24.1046 23 25 22.1046 25 21V19H23.8V21C23.8 21.4418 23.4418 21.8 23 21.8H2C1.55817 21.8 1.2 21.4418 1.2 21V7.2Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6059 10.1757L31.4243 13.9941C31.6586 14.2284 31.6586 14.6083 31.4243 14.8426L27.6059 18.661C27.3716 18.8953 26.9917 18.8953 26.7574 18.661C26.523 18.4267 26.523 18.0468 26.7574 17.8125L29.5515 15.0184L21 15.0184L21 13.8184L29.5515 13.8184L26.7574 11.0243C26.523 10.79 26.523 10.4101 26.7574 10.1757C26.9917 9.94142 27.3716 9.94142 27.6059 10.1757Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22L12 6L13.2 6L13.2 22L12 22Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportTableNormal);
export default __webpack_public_path__ + "static/media/export-table-normal.8c70dea9.svg";
export { ForwardRef as ReactComponent };